import { filters } from '../data/filters.js';
import { pagination } from '../data/pagination.js';

export default function paramsToFilters(params) {

    const filterKeys = [...params.keys()];

    filterKeys.forEach((key) => {

        const values = params.getAll(key);

        for (let i = 0; i < filters.length; i++) {

            if (filters[i].name === key) {

                const filter = filters[i];

                for (let j = 0; j < filter.options.length; j++) {

                    const option = filter.options[j];

                    if (values.includes(option.id)) {

                        // reset our pagination: the results are about to change
                        pagination.offset = 0;

                        // change the filter option's 'checked' attribute
                        option.checked = true;

                    }

                }

            }

        }

    });

}
